import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import ProductDashboard from "@/polymet/pages/product-dashboard";
import EnhancedProductDashboard from "@/polymet/pages/enhanced-product-dashboard";
import StreamlinedProductDashboard from "@/polymet/pages/streamlined-product-dashboard";
import ReportsPage from "@/polymet/pages/reports-page";
import StarterPage from "@/pages/StarterPage";
import LoginPage from "@/pages/LoginPage";
import ProtectedRoute from "./ProtectedRoute"; // Import ProtectedRoute
import { Toaster } from "@/components/ui/toaster";

export default function App() {
  return (
    <Router>
      <Routes>
        <Route path="/login" element={<LoginPage />} />

        {/* Protected Routes */}
        <Route 
          path="/" 
          element={<ProtectedRoute><StarterPage /></ProtectedRoute>} 
        />
        <Route 
          path="/dashboard/:taskId" 
          element={<ProtectedRoute><StreamlinedProductDashboard /></ProtectedRoute>} 
        />
        <Route
          path="/enhanced-dashboard"
          element={<ProtectedRoute><EnhancedProductDashboard /></ProtectedRoute>}
        />
        <Route 
          path="/original-dashboard" 
          element={<ProtectedRoute><ProductDashboard /></ProtectedRoute>} 
        />
        <Route
          path="/streamlined-dashboard"
          element={<ProtectedRoute><StreamlinedProductDashboard /></ProtectedRoute>}
        />
        <Route 
          path="/projects" 
          element={<ProtectedRoute><StreamlinedProductDashboard /></ProtectedRoute>} 
        />
        <Route 
          path="/ingredients" 
          element={<ProtectedRoute><StreamlinedProductDashboard /></ProtectedRoute>} 
        />
        <Route 
          path="/reports" 
          element={<ProtectedRoute><ReportsPage /></ProtectedRoute>} 
        />
      </Routes>
      <Toaster />
    </Router>
  );
}
